import { Component } from "../components/index"
import gsap from "gsap"
import { qsa, qs } from "../utils/index"
import TextSplitScrollTrigger from "../components/TextSplitScrollTrigger"

export default class HeroArticle extends Component {
  constructor(obj) {
    super(obj)

    this.splitText = qsa("[data-split]", this.el)
    this.textSplitter = new TextSplitScrollTrigger({
      el: this.el,
      splitText: this.splitText,
      animate: this.animate.bind(this),
    })

    gsap.set(this.el, { autoAlpha: 0 })
  }

  animate() {
    const img = qs(".img", this.el)
    const lines = qsa(".line-0", this.el)
    const title = qsa(".title .char-1", this.el)
    const dateAndAuthor = qsa(".date, .author", this.el)

    lines.forEach(line => {
      line.style.overflow = "hidden"
    })

    gsap.from(img, {
      y: 200,
      autoAlpha: 0,
      duration: 1.2,
    })

    gsap.from(title, {
      y: "100%",
      stagger: 0.01,
      duration: 1.2,
      scrollTrigger: {
        trigger: title,
        start: "top bottom",
      },
    })

    gsap.from(dateAndAuthor, {
      y: "100%",
      stagger: 0.05,
      autoAlpha: 0,
      duration: 1.2,
      scrollTrigger: {
        trigger: dateAndAuthor,
        start: "top bottom",
      },
    })

    gsap.set(this.el, { autoAlpha: 1 })
  }
}
